import { createSlice } from "@reduxjs/toolkit";

/**
 * @name @createSlice
 * @description create redux store slice for auth
 **/
export const staticDashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    cardDetails: null,
  },

  reducers: {
    /**
     * @name @login
     * @description login reducer to call login async API with axios instance
     * @requires ApiServices.get method, state and API payload
     **/
    setDashboardCardDetails: (state, action) => {
      state.cardDetails = action.payload;
    },
  },
});

export const { setCreateData } = staticDashboardSlice.actions;

/**
 * These function called thunk and allows to perform async logic
 * It can be dispatched like a regular action: `dispatch(data)`
 **/

/* called a selector and allows to select values from the state */
export const getDashboardCardDetails = (state) => {
  return state.dashboard.cardDetails;
};

export default staticDashboardSlice.reducer;
